var $ = require('jquery');
var NotificationBase = require('../NotificationBase');
(function() {

    var XingVouchersNotification = NotificationBase.extend({
        /**
         * Default sticky for XingVouchersNotification
         */
        stickyDefault: 1,
        /**
         * Default severity for XingVouchersNotification
         */
        severityDefault: 4,
        /**
         * Default category for XingVouchersNotification
         */
        categoryDefault: 2,
        /**
         * parameters for determining default operation,
         * if null or false, they are ignored
         */
        iconCls: 'ui-icon-star',
        /**
         * this method must be implemented by all Notifications
         */
        getCssClassSuffix: function() {
            return 'xing-promo';
        },
        getContent: function() {
            var msgs = jimdoData.messages.xingPromo, $content = '';
            if (jimdoData.notificationData.hasOwnProperty('xingPromo')) {
                $content = $(
                    '<div class="title">' + msgs.title + '</div>' +
                    '<div class="description">' + msgs.content + '&nbsp;' + jimdoData.notificationData.xingPromo.voucherCode + '</div>' +
                    '<div class="button-bar cp-style">' +
                    '<button class="small blue-primary">' + msgs.label + '</button>' +
                    '</div>'
                );

                $content.find('button')
                    .button()
                    .bind('click', function() {
                        diy.util.redirector.redirect(jimdoData.notificationData.xingPromo.landingPageUrl);
                    });
            }

            return $content;
        },

        globalAction: false,

        getName: function() {
            return 'XingVouchersNotification';
        }
    });

    module.exports = XingVouchersNotification;
}());



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/toolbar/notification/Notifications/XingVouchersNotification.js
 ** module id = 662
 ** module chunks = 0
 **/